import _extends from "@babel/runtime/helpers/extends";

/*
 * @Author: wangshengqiang
 * @Date: 2021-04-22 16:01:05
 * @LastEditTime: 2022-01-10 15:55:01
 * @LastEditors: wangshengqiang
 * @Description: sd
 */
import React, { useRef, useCallback } from 'react'; // import classnames from 'classnames';

import { Toast } from 'zarm';
import request from '@/utils/request';
import { getState, getFormValue } from '@/store';
import { getQueryParam } from '@/utils/tool';
import { getPreLeveFormKey, getStatePath } from '@/utils/utils';
import { PLAN_ID } from '@/constants';
import RowInput from '../RowInput';
import Ticktock from './Ticktock';
import './index.less';
const KEY = 'phoneNo'; // const PHONE_KEY = 'policyHolder.phoneNo';
// const VALIDATE_CODE_KEY = 'policyHolder.validateCode';

const useEventCallback = fn => {
  const ref = useRef(fn);
  ref.current = fn;
  return useCallback((...args) => {
    const {
      current
    } = ref;
    return current && current(...args);
  }, [ref]);
};

const VerifyCode = /*#__PURE__*/React.forwardRef((props = {}) => {
  const ticktockRef = useRef();
  const {
    formKey
  } = props; // const cls = classnames({
  //   'components-validate-code-render': true,
  //   'cc-row-input': true,
  //   [className]: !!className,
  // });

  const preFormKey = getPreLeveFormKey(formKey);
  const onClickSendSms = useEventCallback(async () => {
    const planId = getState(PLAN_ID);
    const target = getFormValue(`${preFormKey}.${KEY}`);
    const {
      templateRelationId,
      promotionId = templateRelationId
    } = getQueryParam();
    const data = {
      planId,
      target,
      promotionId,
      businessType: 'normalValidate',
      validateCodeType: 'smsValidateCode'
    };
    const opts = {
      method: 'POST',
      data
    };
    const res = (await request('/v1/insure/sendValidateCode', opts)) || {};
    const {
      code,
      message = '网络异常，请稍后重试',
      result
    } = res;

    if (res.success) {
      ticktockRef.current.start();
    }

    Number(code) && Toast.show(message);
    return result;
  });
  const onClickBeforeSendSms = useEventCallback(e => {
    const phoneKey = getStatePath(formKey, KEY);
    const phone = getFormValue(phoneKey) || '';
    const reg = /^1[3|4|5|8|7|9][0-9]\d{8}$/;
    const useful = reg.test(phone);

    if (useful) {
      return;
    }

    e.stopPropagation();
    Toast.show('请输入正确的手机号后获取验证码');
  });

  const ValidateCode = async (rule, value, callback) => {
    const phoneKey = getStatePath(formKey, KEY);
    const target = getFormValue(phoneKey) || '';

    if (!target) {
      callback(new Error('请输入手机号'));
      return;
    }

    if (!value) {
      callback(new Error('请输入验证码'));
      return;
    }

    const planId = getState(PLAN_ID);
    const {
      templateRelationId,
      promotionId = templateRelationId
    } = getQueryParam();
    const data = {
      planId,
      target,
      validateCode: value,
      promotionId,
      businessType: 'normalValidate',
      validateCodeType: 'smsValidateCode'
    };
    const opts = {
      method: 'POST',
      data
    };
    const res = (await request('/v1/insure/verifyValidateCode', opts)) || {};
    const {
      message,
      success,
      result
    } = res;

    if (!success || !result) {
      Toast.show(message || '系统异常，请稍后重试');
      callback(new Error(message));
      return;
    }

    callback();
  };

  const description = /*#__PURE__*/React.createElement(Ticktock, {
    ref: ticktockRef,
    className: "input-btn",
    onClick: onClickSendSms,
    onClickCapture: onClickBeforeSendSms
  }, "\u83B7\u53D6\u9A8C\u8BC1\u7801");
  const inputProps = {
    inputType: 'text',
    placeholder: '请输入验证码',
    maxLength: 6,
    description,
    validateTrigger: 'no',
    rules: [{
      validator: ValidateCode
    }]
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "components-validate-code-render"
  }, /*#__PURE__*/React.createElement(RowInput, _extends({}, props, inputProps), " "));
});
export default VerifyCode;